import { render, staticRenderFns } from "./outProblems.vue?vue&type=template&id=b328cfac&scoped=true&"
import script from "./outProblems.vue?vue&type=script&lang=js&"
export * from "./outProblems.vue?vue&type=script&lang=js&"
import style0 from "./outProblems.vue?vue&type=style&index=0&id=b328cfac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b328cfac",
  null
  
)

export default component.exports